export const MAX_HINTS_PER_QUESTION = 3;
export const MAX_LIVES = 5;
export const BASE_SCORE = 120;
export const MIN_SCORE = 40;
export const HINT_PENALTY = 20;
export const WRONG_ANSWER_PENALTY = -50;
